import { useQuery } from 'react-query';
import { EventFilter } from '../../../../Events/Utilities/EventsApiService';
import healthDashboardApiService from '../../../Health/Utilities/HealthDashboardApiService';
import GatewayHealthDetails from '../../../Health/Components/Gateways/GatewayHealthDetails';
import LoadingSpinner from '../../../../Shared/Components/LoadingSpinner';
import { ReactQueryKeys } from '../../../../../Constants/ClientRoutingConstants';
import DeviceInfoReadDto from '../../../../../Models/Dashboard/DeviceInfoReadDto';
import DeviceNotificationsReadDto from '../../../../../Models/Dashboard/DeviceNotificationsReadDto';

interface Props {
  serialNumber: string;
  gatewayId: string;
  eventFilter: EventFilter;
  setEventFilter: (filter: EventFilter) => void;
  chartParentHeight: number;
  /** Reports whether the timeline has any series to draw. */
  onHasData?: (hasData: boolean) => void;
}

/** Gateway status timeline with its own data fetching. Shared by the gateway dialog and the Insights detail panel. */
export default function GatewayTimelineChart({
  serialNumber,
  gatewayId,
  eventFilter,
  setEventFilter,
  chartParentHeight,
  onHasData,
}: Props) {
  const deviceInfoQuery = useQuery<DeviceInfoReadDto | DeviceInfoReadDto[]>(
    [ReactQueryKeys.DeviceInfoQuery, serialNumber, eventFilter],
    () => healthDashboardApiService.getDeviceInfoChart(eventFilter, serialNumber),
    { enabled: !!serialNumber, keepPreviousData: true }
  );

  const deviceNotificationsQuery = useQuery<DeviceNotificationsReadDto>(
    [ReactQueryKeys.DeviceNotificationsChartQuery, serialNumber, eventFilter],
    () => healthDashboardApiService.getDeviceNotificationsChart(serialNumber, eventFilter),
    { enabled: !!serialNumber, keepPreviousData: true }
  );

  if (deviceInfoQuery.isLoading || deviceNotificationsQuery.isLoading) {
    return (
      <div className="flex items-center justify-center h-full">
        <LoadingSpinner />
      </div>
    );
  }

  const deviceInfo = deviceInfoQuery.data;
  const deviceInfoArray = Array.isArray(deviceInfo) ? deviceInfo : deviceInfo ? [deviceInfo] : [];

  return (
    <GatewayHealthDetails
      deviceData={{ serialNumber }}
      eventFilter={eventFilter}
      setEventFilter={setEventFilter}
      chartParentHeight={chartParentHeight}
      selectedEndpointId={gatewayId}
      deviceInfo={deviceInfoArray}
      deviceNotifications={deviceNotificationsQuery.data}
      onHasData={onHasData}
    />
  );
}
